import { Reveal } from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Cuanto tarda en verse resultados?",
    answer:
      "Depende del canal y del punto de partida. En pauta digital normalmente vemos señales tempranas en las primeras semanas y mejoras sostenidas entre 60 y 90 dias con optimizacion continua.",
  },
  {
    question: "Trabajan solo en Costa Rica?",
    answer:
      "Nuestro foco principal es Costa Rica, donde tenemos mayor experiencia en mercado local, audiencias y contexto comercial.",
  },
  {
    question: "Necesito tener pagina web para empezar?",
    answer:
      "No. Si aun no tenes web, la desarrollamos dentro de la estrategia para que tus campanas y contenido conviertan mejor.",
  },
  {
    question: "La llamada inicial tiene costo?",
    answer:
      "No. La llamada inicial es sin compromiso. Revisamos tu situacion actual, prioridades y oportunidades para definir el mejor plan.",
  },
];

export const FAQSection = () => {
  return (
    <section id="faq" className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <Reveal className="text-center mb-10 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4">
            Preguntas frecuentes
          </h2>
          <p className="text-base sm:text-lg text-primary">
            Respuestas claras para que tomes una decision con confianza.
          </p>
        </Reveal>

        <Reveal delay={1}>
          <Accordion
            type="single"
            collapsible
            className="w-full bg-card rounded-2xl border border-border px-5 sm:px-8 hover:border-accent transition-colors"
          >
            {faqs.map((item) => (
              <AccordionItem key={item.question} value={item.question}>
                <AccordionTrigger className="text-left text-sm sm:text-base font-semibold text-primary">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base text-foreground/85">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
